import { ShoppingCart, Wallet, Upload, ClipboardList, Cloud } from "lucide-react";

export const ALL_TLDS = ["com", "net", "org", "io", "news", "co", "us", "info", "biz", "me"];
export const GEN_TLDS = ["com", "net", "ai", "io", "co", "finance"];
export const STEP_LABEL = { purchase: "Buy", site: "Site", cloudflare: "Cloudflare", nameservers: "NS", email: "Email" };
export const DOMAIN_RE = /^(?=.{1,253}$)([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/;
export const LARGE_BATCH = 25;
export const PHASES = ["collect", "review", "progress"];

export const REGISTRARS = [
  { key: "namecheap", label: "Namecheap", icon: Wallet, hint: "pays from your prepaid Namecheap balance" },
  { key: "cloudflare", label: "Cloudflare Registrar", icon: Cloud, hint: "at-cost pricing · charged to your Cloudflare card · NS auto-set" },
];

export const LANES = [
  { key: "buy", label: "Buy new", icon: ShoppingCart },
  { key: "owned", label: "Add owned", icon: ClipboardList },
  { key: "import", label: "Import from Namecheap", icon: Upload },
  { key: "import-cf", label: "Import from Cloudflare", icon: Cloud },
];

const LANE_FOLDER_PREFIX = { owned: "Owned Import", import: "Namecheap Import", "import-cf": "Cloudflare Import" };
const RESULTS_SOURCE_LABEL = { generate: "generated", suggest: "suggested by Cloudflare", search: "checked" };

export const btnPrimary = "inline-flex items-center justify-center gap-2 bg-amber-500 text-zinc-950 hover:bg-amber-400 disabled:opacity-40 px-5 py-2.5 rounded-sm text-sm font-semibold transition-colors";
export const btnGhost = "inline-flex items-center gap-2 border border-zinc-700 hover:border-zinc-500 text-zinc-200 disabled:opacity-40 px-4 py-2.5 rounded-sm text-sm font-semibold";
export const inputCls = "admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm";

export const registrarLabel = (registrar) => (registrar === "cloudflare" ? "Cloudflare Registrar" : "Namecheap");
export const registrarShort = (registrar) => (registrar === "cloudflare" ? "Cloudflare" : "Namecheap");
export const importSourceLabel = (lane) => (lane === "import-cf" ? "Cloudflare Registrar" : "Namecheap");
export const resultsSourceLabel = (source) => RESULTS_SOURCE_LABEL[source] || "checked";
export const isValidDomain = (d) => DOMAIN_RE.test(d);

export function defaultFolderName(lane, registrar) {
  const d = new Date().toLocaleDateString("en-US", { month: "short", day: "numeric" });
  const prefix = lane === "buy" ? `${registrarShort(registrar)} Buy` : LANE_FOLDER_PREFIX[lane] || "Owned Import";
  return `${prefix} — ${d}`;
}

export function parseDomains(text) {
  return Array.from(new Set(
    (text || "")
      .split(/[\s,;]+/)
      .map((s) => s.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/\/.*$/, "").replace(/\.$/, ""))
      .filter(Boolean)
  ));
}

export function toggleInSet(set, value) {
  const n = new Set(set);
  if (n.has(value)) n.delete(value); else n.add(value);
  return n;
}
